import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '@environments/environment'
import { PolicyApiResponse, PolicyAssetsApiResponse, PolicyStatusType } from '@features/insured/models/policy/policy.model'
import { hasActualValue } from '@core/utils/form-utils'

@Injectable({
  providedIn: 'root'
})
export class PolicyService {
  private readonly http = inject(HttpClient)
  private readonly apiUrl = environment.policyApiUrl

  public getById(uuid: string): Observable<PolicyApiResponse> {
    return this.http.get<PolicyApiResponse>(`${this.apiUrl}/${uuid}`)
  }

  public getByMemberIdAndPeriodId(memberId: string, periodId: string, status?: PolicyStatusType): Observable<PolicyApiResponse[]> {
    return this.http.get<PolicyApiResponse[]>(
      `${this.apiUrl}`,
      {
        params: {
          ...(status && { status }),
          periodId,
          memberId
        }
      }
    )
  }

  public create(policy: PolicyApiResponse): Observable<PolicyApiResponse> {
    return this.http.post<PolicyApiResponse>(`${this.apiUrl}`, policy)
  }

  public update(policy: PolicyApiResponse): Observable<PolicyApiResponse> {
    return this.http.put<PolicyApiResponse>(`${this.apiUrl}`, policy)
  }

  public save(policy: PolicyApiResponse): Observable<PolicyApiResponse> {
    return hasActualValue(policy.uuid)
      ? this.update(policy)
      : this.create(policy)
  }

  public getAssets(policyId: string): Observable<PolicyAssetsApiResponse> {
    return this.http.get<PolicyAssetsApiResponse>(`${this.apiUrl}/${policyId}/assets`)
  }
}
